<template v-once>
  <canvas id="noise" ref="noise" :style="{ opacity: opacity }"></canvas>
</template>

<script>

export default {
  name: 'noise',
  props: {
    opacity: {
      type: Number,
      default () {
        return 0.05
      }
    }
  },
  computed: {
    scaleFactor () {
      // Higher pixel ratio reduces the noise grain size...
      // best to keep ratio at 1 and let the device upscale
      return 1
    },
    fullWidth () {
      return (window.screen) ? screen.availWidth : window.innerWidth
    },
    fullHeight () {
      return window.innerHeight
    }
  },
  methods: {
    generateNoise () {
      this.$refs.noise.width = this.fullWidth * this.scaleFactor
      this.$refs.noise.height = this.fullHeight * this.scaleFactor
      let nCtx = this.$refs.noise.getContext('2d')
      this.noise = nCtx.createImageData(this.fullWidth * this.scaleFactor, this.fullHeight * this.scaleFactor)
      this.noiseBuffer = new Uint32Array(this.noise.data.buffer)
      for (let i = 0; i < this.noiseBuffer.length;) {
        this.noiseBuffer[i++] = ((255 * Math.random()) | 0) << 24
      }
      nCtx.putImageData(this.noise, 0, 0)
    }
  },
  mounted () {
    this.generateNoise()
  }
}
</script>

<style lang="scss" scoped>
@import "~@/assets/scss/global/the_goods";

#noise {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 12;
  opacity: 0;
  transition: opacity 3s;

  &.fixed {
    position: fixed;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/demos/Noise.vue